import {takeLatest} from 'redux-saga/effects';
import types from '../../../../../../../actions/types';
import {fetchItemSaga} from '../../../../../../../sagas/common-sagas';
import {buildPaginationUrl} from '../../../../../../../utils/url';

function* getGames(action) {
    yield fetchItemSaga(buildPaginationUrl('/api/games/', action.payload.data.page, action.payload.data.size, action.payload.data), types.GET_GAMES);
}

export default function* mainSagas() {
    yield[takeLatest(types.GET_GAMES.REQUEST, getGames)];
}



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/main/modules/games-main-sagas.js